import type { FC } from "react";

import { cn, makeBreakpointClassName } from "@/ui/lib/utils";
import {
  ASPECT_RATIO_DEFAULTS,
  TAspectRatioProps,
  ASPECT_RATIO_RESPONSIVE_RATIO_CLASS_MAP,
} from "@/ui/components/primitives/AspectRatio";

export const AspectRatio: FC<TAspectRatioProps> = (
  {
    ratio = ASPECT_RATIO_DEFAULTS.ratio,
    "data-component": component = ASPECT_RATIO_DEFAULTS["data-component"],
    className,
    children,
    ...props
  },
) => {

  return (
    <div
      {...props}
      data-component={component}
      className={cn(
        "flex flex-col items-start w-full relative",
        makeBreakpointClassName(ratio, ASPECT_RATIO_RESPONSIVE_RATIO_CLASS_MAP, ASPECT_RATIO_DEFAULTS.ratio),
        className,
      )}
    >
      { children }
    </div>
  );
};

AspectRatio.displayName = "AspectRatio";
